<template>
  <div class="extension__form__inside form--dynamic">
    <div v-for="(row, rowindex) in typeForm.structure" class="form__row" :key="`row-${rowindex}`">
      <div v-for="(col, colindex) in row" class="form__col" :key="`row-${rowindex}-${colindex}`">
        <div v-for="field in col.fields" :key="`field-${rowindex}-${colindex}-${field.name}`" v-if="resolveConditions(field)">
          <field :field="field" v-model="object[field.name]"></field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Field';
import { sluggify } from '@/helpers/string';

export default {
  name: 'dynamic-form',
  components: {
    Field,
  },
  props: ['fields', 'object', 'typeForm'],
  methods: {
    resolveConditions(field) {
      if (!field.conditions) {
        return true;
      }

      let result = true;
      field.conditions.forEach(condition => {
        if (condition.comparison === '==') {
          if (this.object[condition.field] !== condition.value) {
            if (condition.relation === '&&') {
              result = false;
            }
          } else if (condition.relation === '||') {
            result = true;
          }
        }
        if (condition.comparison === '!=') {
          if (this.object[condition.field] === condition.value) {
            if (condition.relation === '&&') {
              result = false;
            }
          } else if (condition.relation === '||') {
            result = true;
          }
        }
      });
      return result;
    },
  },
  watch: {
    object: {
      handler(value) {
        // Special handlers
        this.fields.forEach(field => {
          if (field.sluggify) {
            value[field.sluggify] = sluggify(value[field.name]);
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.form--dynamic {
  padding: 20px 0;
}
.form__row {
  display: flex;
  padding: 10px 0;
}
.form__col {
  flex: 1;
  padding: 0 10px;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
}
</style>
